import styled from "styled-components";

export const SearchPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const SearchPageTable = styled.div`
  background-color: #edf1fc;
  padding: 40px;
  border-radius: 24px;
  gap: 20px;
  max-width: 1400px;
  margin: 40px auto;
  z-index: 10;
  width: 80%;
  height: 100%;
  background-image: url("/assets/bg.png");
`;

export const SearchPageTitle = styled.h1`
  color: #17224d;
  margin-bottom: 30px;
  text-align: center;
`;

export const SearchResultCard = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ResultContent = styled.p`
  font-size: 16px;
  color: #17224d;
  line-height: 1.5;
`;

export const ResultLink = styled.a`
  font-size: 16px;
  color: #0066cc;
  text-decoration: none;
  font-weight: bold;
`;
